app.component('oidcRedirect', {
    bindings: {},
    templateUrl: './App/Login/OidcRedirect/OidcRedirect.html',
    controller: ['configService', '$scope',
        function (configService, $scope) {

        var that = this;

       that.getCookie = function (name) {
            const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
            return match ? decodeURIComponent(match[1]) : null;
       }

        that.redirectToSamlIdP = function () {
            // Build a minimal SAML AuthnRequest
            const idpUrl = that.config.samlIdpFormPostUrl.replace('formpost', 'login');
            const requestId = 'ID' + Math.random().toString(36).substr(2, 16);
            const samlRequestXml = `
                <saml2p:AuthnRequest xmlns:saml2p="urn:oasis:names:tc:SAML:2.0:protocol"
                    AssertionConsumerServiceURL="${that.config.samlSpAcs}"
                    Destination="${idpUrl}"
                    ForceAuthn="false"
                    ID="_${requestId}"
                    IsPassive="false"
                    IssueInstant="` + new Date().toISOString() + `"
                    ProtocolBinding="urn:oasis:names:tc:SAML:2.0:bindings:HTTP-POST"
                    Version="2.0">
                    <saml2:Issuer xmlns:saml2="urn:oasis:names:tc:SAML:2.0:assertion">${that.config.samlSpEntityId}</saml2:Issuer>
                    <saml2p:NameIDPolicy AllowCreate="true" Format="urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified"/>
                </saml2p:AuthnRequest>`;

            const samlRequestB64 = btoa(unescape(encodeURIComponent(samlRequestXml)));

            // Create a form to POST the request
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = idpUrl;

            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'SAMLRequest';
            input.value = samlRequestB64;
            form.appendChild(input);

            // Add clareitysecurity-did cookie if it exists
            const did = that.getCookie('clareitysecurity-did');
            if (did) {
                const didInput = document.createElement('input');
                didInput.type = 'hidden';
                didInput.name = 'clareitysecurity-did';
                didInput.value = did;
                form.appendChild(didInput);
            }

            document.body.appendChild(form);
            form.submit();
        }

        that.init = function () {
            configService.getConfig((response) =>
            {
                that.config = response.data;
                that.redirectToSamlIdP();
            });
        }

        that.init();
    }]
});